import { render, staticRenderFns } from "./TreatmentMedicineFormInPopup.vue?vue&type=template&id=5dbf5c14&scoped=true&"
import script from "./TreatmentMedicineFormInPopup.vue?vue&type=script&lang=js&"
export * from "./TreatmentMedicineFormInPopup.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentMedicineFormInPopup.vue?vue&type=style&index=0&id=5dbf5c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf5c14",
  null
  
)

export default component.exports